/**
 * src/app/marketplace/hooks/accountDetails.js
 * ---------------------------------------------------------------------------
 * Loads the merchant's account details from the marketplace API and seeds the
 * onboarding wizard with them.
 * ---------------------------------------------------------------------------
 */

import axios from 'axios';
import config from '../../../config';

// Keys the onboarding wizard reads its initial state from.
const MAIN_STATE_KEY = 'mainState';
const DATA_KEY = 'data';

// Cookies must ride along for the session to authorize the request.
const withSession = { withCredentials: true };


/**
 * Ensure the onboarding wizard has its prefill, fetches it if not already hold one.
 *
 * @param {string} providerKey
 * @returns {Promise<boolean>}
 */
export async function ensureAccountDetails(providerKey) {
	if (!providerKey) return false;

	// Checks stored account info in session storage.
	if (sessionStorage.getItem(MAIN_STATE_KEY)) return true;

	try {
		const { data } = await axios.get(`${config.partnerApiUrl}/partners/${providerKey}/details`, withSession);
		if (!data || !data.details) return false;

		writeWizardState(data.details);

		return true;
	} catch (e) {
		console.error('marketplace: failed to load account details for prefill:', e.message);

		return false;
	}
}


// ===========================================================================
// Helpers 
// ===========================================================================

/**
 * Writes account info into session storage to prefill in merchant onboarding flow.
 *
 * @param {object} details
 * @returns {void}
 */
function writeWizardState(details) {
	const { campaign, campaignRecordId, ...mainStateFields } = details;

	const existingMainState = sessionStorage.getItem(MAIN_STATE_KEY);
	const mainState = { ...(existingMainState ? JSON.parse(existingMainState) : {}), ...mainStateFields };
	sessionStorage.setItem(MAIN_STATE_KEY, JSON.stringify(mainState));

	const existingData = sessionStorage.getItem(DATA_KEY);
	const data = { ...(existingData ? JSON.parse(existingData) : {}), campaign, campaignRecordId };
	sessionStorage.setItem(DATA_KEY, JSON.stringify(data));
}
